import type { VariantProps } from "@-/com.npmjs.cva";
import { toggleVariants } from "#toggle-variants";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { TextClassContext } from "@-/dev.improve.haniverse.components.ui.text";
import { cn } from "@-/com.npmjs.cn";
import { Root, type RootProps, type RootRef } from "@rn-primitives/toggle";
import { type ComponentProps, type RefAttributes, use } from "react";
import { Platform } from "@-/com.npmjs.react-native";

export function Toggle({
  className,
  size,
  variant,
  ...props
}: RootProps & VariantProps<typeof toggleVariants> & RefAttributes<RootRef>) {
  return (
    <TextClassContext
      value={cn(
        "text-sm font-medium text-foreground",
        props.pressed
          ? "text-accent-foreground"
          : Platform.select({ web: "group-hover:text-muted-foreground" }),
        className,
      )}
    >
      <Root
        className={cn(
          toggleVariants({ size, variant }),
          props.disabled && "opacity-50",
          props.pressed && "bg-accent",
          className,
        )}
        {...props}
      />
    </TextClassContext>
  );
}

export function ToggleIcon({ className, ...props }: ComponentProps<typeof Icon>) {
  const textClass = use(TextClassContext);
  return <Icon className={cn("size-4 shrink-0", textClass, className)} {...props} />;
}
